import { IFilledFormV2, IRootGizmoData } from '../../types';
import { gnov } from '../../utils';

interface IParams {
  data: IRootGizmoData;
}

/**
 * Transform v3 root gizmo data to v3
 *
 * @param {IRootGizmoData} data v3 root gizmo data
 *
 * @returns {IFilledFormV2} v2 filled form
 */
function rootGizmoDataV3ToV2({ data }: IParams): IFilledFormV2 {
  const filledForm: IFilledFormV2 = {
    fid: data.fid,
    filledFormId: data.fid,
    formId: data.formId!,
    formVersion: data.formVersion!,
    version: data.version,
    status: data.status,
    epoch_start: data.epoch_start,
    epoch_end: data.epoch_end,
    source: data.source,
    answers: {},
  };

  if (data.id) {
    filledForm.id = data.id;
    filledForm._id = data.id;
  }

  if (data.belongsTo !== undefined) {
    filledForm.belongsTo = data.belongsTo;
  }

  if (data.offlineStatus !== undefined) {
    filledForm.offlineStatus = data.offlineStatus;
  }

  if (data.action !== undefined) {
    filledForm.action = data.action;
  }

  if (data.d) {
    for (const fid in data.d) {
      const val: any = data.d[fid];

      if (val && val.v !== undefined && !Array.isArray(val.v)) {
        filledForm.answers[fid] = { '0': { value: val.v } };

        if (val.sod) {
          filledForm.answers[fid]['0'].f_id = val.sod.f_id;
          filledForm.answers[fid]['0'].formId = val.sod.formId;
          filledForm.answers[fid]['0'].catalogFid = val.sod.catalogFid;
          if (val.sod.version) {
            filledForm.answers[fid]['0'].version = val.sod.version;
          }
          if (val.sod.id) {
            filledForm.answers[fid]['0'].id = val.sod.id;
          }
          if (val.sod._id) {
            filledForm.answers[fid]['0']._id = val.sod._id;
          }
          if (val.sod.parentOptionId) {
            filledForm.answers[fid]['0'].parentOptionId =
              val.sod.parentOptionId;
          }
        } else if (val.dd) {
          filledForm.answers[fid]['0'].timestamp = gnov(val, 'dd.timestamp');
          filledForm.answers[fid]['0'].timezone = gnov(val, 'dd.timezone');
        } else if (val.fd) {
          filledForm.answers[fid]['0'].attachmentId = gnov(
            val,
            'fd.attachmentId'
          );
          filledForm.answers[fid]['0'].extension = gnov(
            val,
            'fd.fileExtension'
          );
          filledForm.answers[fid]['0'].size = gnov(val, 'fd.fileSize');
          filledForm.answers[fid]['0'].name = gnov(val, 'fd.fileName');
          filledForm.answers[fid]['0'].type = gnov(val, 'fd.fileType');
        } else if (val.id) {
          filledForm.answers[fid]['0'].attachmentId = gnov(
            val,
            'id.attachmentId'
          );
          filledForm.answers[fid]['0'].ocrResult = gnov(val, 'id.ocrResult');
          filledForm.answers[fid]['0'].source = gnov(val, 'id.source');
          filledForm.answers[fid]['0'].extension = gnov(
            val,
            'id.fileExtension'
          );
          filledForm.answers[fid]['0'].size = gnov(val, 'id.fileSize');
          filledForm.answers[fid]['0'].name = gnov(val, 'id.fileName');
          filledForm.answers[fid]['0'].type = gnov(val, 'id.fileType');
          filledForm.answers[fid]['0'].onlyFront = gnov(val, 'id.onlyFront');
        } else if (val.sd) {
          filledForm.answers[fid]['0'].filledFormId = gnov(val, 'sd.filledFormId');
          filledForm.answers[fid]['0'].f_id = gnov(val, 'sd.f_id');
          filledForm.answers[fid]['0'].formId = gnov(val, 'sd.formId');
          filledForm.answers[fid]['0'].answers = gnov(val, 'sd.answers');
        } else if (val.td) {
          filledForm.answers[fid]['0'].scannedCurp = gnov(val, 'td.scannedCurp');
        }
      } else if (val && Array.isArray(val) && val.length > 0) {
        filledForm.answers[fid] = {};

        for (let i = 0; i < val.length; i++) {
          const v = val[i];

          if (v.afd) {
            filledForm.answers[fid][i.toString()] = v.afd;
          } else if (v.sod) {
            filledForm.answers[fid][i.toString()] = {
              value: v.v,
              f_id: v.sod.f_id,
              formId: v.sod.formId,
              version: v.sod.version,
              id: v.sod.id,
              _id: v.sod._id,
            };
            if (v.sod.parentOptionId) {
              filledForm.answers[fid][i.toString()].parentOptionId =
                v.sod.parentOptionId;
            }
          } else if (v.id) {
            filledForm.answers[fid][i.toString()] = {
              value: v.v,
              ocrResult: v.id.ocrResult,
              source: v.id.source,

              attachmentId: v.id.attachmentId,
              extension: v.id.fileExtension,
              size: v.id.fileSize,
              name: v.id.fileName,
              type: v.id.fileType,

              onlyFront: v.id.onlyFront,
            };
          }
        }
      }
    }
  }

  return filledForm;
}

export default rootGizmoDataV3ToV2;
